import { Doi } from '@sage-bionetworks/synapse-types'

export const MOCK_DOI: Doi = {
  creators: [
    { creatorName: 'Farnsworth, Hubert' },
    { creatorName: 'Wong, Amy' },
  ],
  titles: [{ title: 'Mathematics of quantum neutrino fields' }],
  publicationYear: 3024,
}
